const useToken = () => {
  const setToken = (token) => {
    localStorage.setItem('token', token)
  }

  const getToken = () => {
    return localStorage.getItem('token')
  }

  const deleteToken = () => {
    localStorage.removeItem('token')
  }

  return { setToken, getToken, deleteToken }
}

export default useToken
